import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';

export const appInterceptor: HttpInterceptorFn = (req, next) => {

  return next(req).pipe(
    tap((event) => {

      if (event instanceof HttpResponse) {

        const newToken = event.headers.get('x-new-token');
        // console.log(newToken)
        // console.log(`Response from: ${req.url}`);

        if (newToken) {
          console.log('New SSO Token received');
          localStorage.setItem('sso-session', newToken);
        }

      }

    })
  );

};